
export class MtmaDtmf {
    Description: string;
    Code: string;
    ObjId: string;
    Action: number;
    Fixed: boolean;
}
